// extracted by mini-css-extract-plugin
module.exports = {"labelClass":"xz","inputClass":"xA"};